<template></template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from "vuex";

export default {
  mixins: [],
  data() {
    return {};
  },
  props: [],
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectSprites_Msg",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      "WorksDraftNum",
    ]),
  },
  watch: {},
  mounted() {},
  methods: {
    judgeVip_worksDraftNum(type) {
      // 作品数量判断 传值的话判断项目，不传值判断作品
      const vm = this;
      // return new Promise((resolve, reject) => { resolve(false); });
      return this.$http
        .get("/api/user/limit", {
          params: {
            type: "draft-work-transform",
          },
        })
        .then((res) => {
          let data = res.data.data;
          for (let item in data) {
            let pushList = false;
            let itemData = data[item];
            switch (item) {
              case "draft":
                if (type && type == "draft" && itemData.exceed) {
                  pushList = true;
                }
                break;
              case "work":
                if (itemData.num > itemData.limit) {
                  pushList = true;
                }
                break;
              default:
                if (itemData.exceed) {
                  pushList = true;
                }
            }

            if (pushList) {
              this.$store.commit("push_worksDraftNum", itemData);
            }
          }
          if (this.WorksDraftNum.length) {
            this.closePace();
            this.$bus.emit("FeaturesPop_close_vue", {
              name: "vipEquity",
              type: 2,
            });
            if (
              this.WorksDraftNum.length === 1 &&
              this.WorksDraftNum[0].type === "transform" || this.WorksDraftNum[0].type === 'work'
            ) {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            }
            return new Promise((resolve, reject) => {
              resolve(true);
            });
          } else {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          }
        });
    },
    closePace() {
      let paceDom = document.getElementsByClassName("pace-inactive")[0];
      if (!paceDom) {
        let timeoutid = setTimeout(() => {
          this.closePace();
          clearTimeout(timeoutid);
        }, 200);
      } else {
        paceDom.style.display = "none";
      }
    },
    vipPopups() {
      let msgTitle = "";
      let vipLevel = "solo";
      let jumpUrl = "/vipsolo";
      let recommendVip = "";
      let hasCloseIcon = false;
      switch (this.WorksDraftNum.length) {
        case 1:
          let itemData = this.WorksDraftNum[0];
          switch (itemData.type) {
            case "draft":
              if (itemData.limit == 100) {
                msgTitle =
                  "您当前最多只能保留100个项目，请先删除已有项目或开通企业会员可无限使用。";
                vipLevel = "vip";
                jumpUrl = "/vip";
              } else {
                msgTitle =
                  "您当前最多只能保留10个项目，请先删除已有项目或升级个人VIP，可扩充到100个。";
                recommendVip = "项目容量无限制，点击了解高级会员";
              }
              break;
            // case "transform":
            //   hasCloseIcon = true;
            //   if (this.UserLevelType === 0 && this.UserLevel === 0) {
            //     msgTitle = `您的${this.UserMsg.transformRemains}次视频导出权益已经使用完毕，升级个人VIP，可无限使用。`;
            //   } else {
            //     msgTitle = `您的视频导出权益已经使用完毕。`;
            //     vipLevel = "vip";
            //     jumpUrl = "/vip";
            //   }
            //   break;
            case "work":
              if (itemData.limit == 200) {
                msgTitle =
                  "您当前最多只能保留200个作品，请先删除已有作品或开通企业会员可无限使用。";
                vipLevel = "vip";
                jumpUrl = "/vip";
              } else {
                msgTitle =
                  "您当前最多只能保留20个作品，请先删除已有作品或升级个人VIP扩充作品数量至200个。";
                recommendVip = "作品容量无限制，点击了解高级会员";
              }
              break;
          }
          break;
        case 2:
          let video = false,
            draft = false,
            work = false;
          for (let i = 0; i < this.WorksDraftNum.length; i++) {
            let itemData = this.WorksDraftNum[i];

            switch (itemData.type) {
              case "draft":
                if (itemData.limit == 100) {
                  vipLevel = "vip";
                }
                draft = itemData;
                break;
              case "transform":
                video = itemData;
                break;
              case "work":
                if (itemData.limit == 200) {
                  vipLevel = "vip";
                }
                work = itemData;
                break;
            }
          }
          if (vipLevel == "solo") {
            if (draft && work) {
              msgTitle =
                "您当前最多只能保留10个项目和20个作品，请先删除已有作品项目或升级个人VIP扩充作品数量至200个，项目数量至100个。";
              recommendVip = "项目、作品容量无限制，点击了解高级会员";
            } else if (draft && video) {
              msgTitle = `您的视频导出权益${this.UserEquity.exportNum}次及项目容量池10个已达上限，请升级个人VIP扩展权益。`;
            } else if (work && video) {
              msgTitle = `您的视频导出权益${this.UserEquity.exportNum}次及作品容量池20个已达上限，请升级个人VIP扩展权益。`;
            }
          } else {
            msgTitle =
              "您当前最多只能保留100个项目和200个作品，请先删除已有作品项目或开通企业会员可无限使用";
            jumpUrl = "/vip";
          }
          break;
        case 3:
          msgTitle = `您的视频导出权益${this.UserEquity.exportNum}次及项目作品容量池已达上限，请升级个人VIP扩展权益。`;
          break;
      }
      if (this.WorksDraftNum.length) {
        this.$bus.emit("FeaturesPop_vue", {
          name: "vipEquity",
          msg: msgTitle,
          btnMsg: "立即开通",
          btnMsgLink: jumpUrl,
          levelType: vipLevel,
          hasCloseIcon: false,
          linkTarget: "",
          recommendVip: recommendVip,
          type: 2,
          toManage: msgTitle.indexOf("先删除") > -1 ? "去删除作品项目" : "",
          hasCloseIcon,
        });
      }
    },
  },
  components: {},
};
</script>



// WEBPACK FOOTER //
// src/components/mixins/judgeVip/judgeVipEvent.vue